import { useNavigate } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="nf-page">
      <div className="nf-inner">
        <img src="/images/logo.png" alt="FocusOne" className="nf-logo" />
        <div className="nf-code">404</div>
        <div className="nf-title">Page Not Found</div>
        <div className="nf-msg">
          The page you are looking for doesn&apos;t exist or has been moved.
        </div>
        <button
          type="button"
          className="nf-btn"
          onClick={() => navigate('/')}
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
}
